import { lidService } from '@/api/lidService';

export * from '@/api/lidService';

export const authRequireServices = [lidService];
